var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlertSingle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#024BD5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.8634 19.6621C34.3263 19.6621 32.2079 21.4335 31.6445 23.7988H16.2211C15.6853 22.0597 14.0855 20.7886 12.1713 20.7886C9.82308 20.7886 7.91724 22.6927 7.91724 25.0427C7.91724 27.3909 9.82307 29.2968 12.1713 29.2968C14.1622 29.2968 15.8213 27.9235 16.2857 26.0773H31.5885C32.0736 28.5497 34.2517 30.4215 36.8634 30.4215C39.8294 30.4215 42.2424 28.0086 42.2424 25.0427C42.2424 22.0768 39.8294 19.6621 36.8634 19.6621V19.6621ZM36.8633 28.3799C35.0223 28.3799 33.5249 26.8825 33.5249 25.0431C33.5249 23.2019 35.0223 21.7062 36.8633 21.7062C38.7046 21.7062 40.202 23.2019 40.202 25.0431C40.202 26.8825 38.7046 28.3799 36.8633 28.3799Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertSingle);
export default __webpack_public_path__ + "static/media/alert-single.fc09855e.svg";
export { ForwardRef as ReactComponent };